module.exports = __webpack_public_path__ + "assets/img/store-text-phone-1.a174fd61.png";